import { ROUTE_FILE } from '../routing';
import {
  getHasUnsavedEdits,
  HIDE_UNSAVED_CHANGES_PROMPT,
  SHOW_UNSAVED_CHANGES_PROMPT,
} from '.';

// VE-30183: holds navigation away from a file with unsaved transcript edits until the
// "Unsaved Changes" prompt answers. redux-first-router calls `confirmLeave` on every route
// change while ROUTE_FILE is active and waits for the callback given to `displayConfirmLeave`.

export const UNSAVED_CHANGES_MESSAGE =
  'You have unsaved transcript edits. Save them before leaving this file?';

export const confirmLeaveFile = (
  state: any,
  action: {
    type?: string;
    payload?: { tdoId?: string | number | null; [key: string]: unknown };
  }
) => {
  if (!getHasUnsavedEdits(state)) {
    return undefined;
  }
  const currentTdoId = state?.location?.payload?.tdoId;
  // same file, e.g. a query string change: nothing is left behind
  if (
    action?.type === ROUTE_FILE.type &&
    currentTdoId !== undefined &&
    String(action.payload?.tdoId) === String(currentTdoId)
  ) {
    return undefined;
  }
  return UNSAVED_CHANGES_MESSAGE;
};

let pendingAnswer: ((canLeave: boolean) => void) | null = null;

export const displayUnsavedChangesPrompt =
  (getDispatch: () => ((action: unknown) => unknown) | undefined) =>
  (message: string, callback: (canLeave: boolean) => void) => {
    const dispatch = getDispatch();
    if (!dispatch) {
      callback(true);
      return;
    }
    pendingAnswer = callback;
    dispatch(SHOW_UNSAVED_CHANGES_PROMPT({ message }));
  };

// true lets the held navigation through, false stays on the file
export const answerUnsavedChangesPrompt =
  (canLeave: boolean) => (dispatch: (action: unknown) => unknown) => {
    const answer = pendingAnswer;
    pendingAnswer = null;
    dispatch(HIDE_UNSAVED_CHANGES_PROMPT());
    answer?.(canLeave);
  };
